/// <reference path="./window.d.ts" />
import { computed, Inject, Injectable, Optional, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WindowRefService {
  private iframeType = signal<string>(null);
  inSemrushIframe = computed(
    () => this.iframeType() === 'semrush' || this.iframeType() === 'va'
  );
  inVaIframe = computed(() => this.iframeType() === 'va');
  inIframe = computed(() => this.iframeType() != null);
  private iframeTest = signal<boolean>(false);
  testingIframe = computed(() => this.iframeTest());

  constructor(@Optional() @Inject('window') private window?: Window) {
    // eslint-disable-next-line local-rules/no-window-location
    const search = (this.window || globalThis.window)?.location?.search;
    if (search?.includes('is_semrush_iframe')) {
      this.iframeType.set('semrush');
    }
    if (search?.includes('is_va_iframe')) {
      this.iframeType.set('va');
    }
    if (search?.includes('testing_iframe=true')) {
      this.iframeTest.set(true);
    }
  }

  public nativeWindow(): any {
    /*
      used in various parts of our angular apps to
      dermine what to do for mobile users

      taken from: http://stackoverflow.com/questions/3514784/what-is-the-best-way-to-detect-a-handheld-device-in-jquery
    */
    this._nativeWindow.isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        this._nativeNavigator.userAgent
      );

    return this._nativeWindow;
  }

  public get _nativeWindow() {
    return this.window || (globalThis.window as any);
  }

  public get _nativeNavigator() {
    return navigator;
  }

  public get isSalesforceCanvas(): boolean {
    return (this.nativeWindow() as Window).isSalesforceCanvas;
  }

  public postTopMessage(message: any, target: string): void {
    this.nativeWindow().top?.postMessage(message, target);
  }
}
